import React, { ComponentPropsWithoutRef } from 'react';
import { resolveStaticSrc } from '../utils/staticLinkUtils';

type MarkdownSourceProps = ComponentPropsWithoutRef<'source'>;

export default function MarkdownSource({ src, ...otherProps }: MarkdownSourceProps) {
  const resolvedSrc = resolveStaticSrc(src);
  return (
    // TODO: CRK-374 - replace this with Image component from @rbx/ui
    <source {...otherProps} src={resolvedSrc} />
  );
}
